module.exports = __webpack_public_path__ + "img/across back.8352f4cb.png";